import React, { createContext, useContext, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux'; // Importamos el despachador de Redux
import * as signalR from '@microsoft/signalr';
import { actualizarDocumentoPorWebSocket, fetchDatosIniciales } from '../features/map/mapSlice';

const SignalRContext = createContext(null);

export const SignalRProvider = ({ children }) => {
  const dispatch = useDispatch();
  const [conectado, setConectado] = useState(false);

  useEffect(() => {
    const baseUrl = process.env.REACT_APP_API_URL;

    // 1. Configurar el cliente oficial manteniendo logs y reconexión automática
    const nuevaConexion = new signalR.HubConnectionBuilder()
      .withUrl(`${baseUrl}/databaseHub`) 
      .withAutomaticReconnect({
          nextRetryDelayInMilliseconds: (retryContext) => {
            // Si ha fallado muchas veces, se queda reintentando fijamente cada 5 segundos de forma infinita
            return 5000; 
          }
        })
      // .configureLogging(signalR.LogLevel.Information) // Mantiene los logs de protocolo en la consola
      .configureLogging(signalR.LogLevel.None) //Para que no logee
      .build();

    // 2. Escuchar el evento manteniendo el mapeo de los dos parámetros detectados en Postman
    nuevaConexion.on("ReceiveDatabaseChange", (operationType, documentoLimpio) => {
      // console.log(`📁 [SignalR] Operación detectada en BD: ${operationType}`);
      // console.log("⚡ [SignalR] Objeto limpio recibido de .NET:", documentoLimpio);
      
      // 3. Despachar los datos directamente a Redux para actualizar el estado global
      if (documentoLimpio && documentoLimpio._id) {
        dispatch(actualizarDocumentoPorWebSocket(documentoLimpio));
        // console.log(`✨ [SignalR] Estado de Redux actualizado para el ID: ${documentoLimpio._id}`);
      } else {
        // console.warn("⚠️ [SignalR] Se recibió un documento pero no contiene un _id válido.");
      }
    });

    // 4. Iniciar la conexión de WebSocket y gestionar estados de log visual
    nuevaConexion.start()
      .then(() => {
        setConectado(true);
        dispatch(fetchDatosIniciales());
        // console.log("🚀 Conectado exitosamente a SignalR!");
      })
      .catch(err => {
        setConectado(false);
        dispatch(fetchDatosIniciales());
        // console.error("❌ Error de conexión inicial en SignalR: ", err);
      });

    // Manejadores de eventos de reconexión para visibilidad en consola
    nuevaConexion.onreconnecting((error) => {
      setConectado(false);
      dispatch(fetchDatosIniciales()); 
      // console.warn("⚠️ [SignalR] Conexión perdida. Intentando reconectar...", error);
    });

    nuevaConexion.onreconnected((connectionId) => {
      setConectado(true);
      dispatch(fetchDatosIniciales());
      // console.log(`✅ [SignalR] Reconexión exitosa. Nuevo ConnectionID: ${connectionId}`);
    });

    nuevaConexion.onclose((error) => {
      setConectado(false);
      dispatch(fetchDatosIniciales());
      // console.error("🛑 [SignalR] La conexión se cerró por completo y no pudo reconectar.", error);
    });

    // 5. Limpieza automática cuando el proveedor se desmonte
    return () => {
      nuevaConexion.stop();
    };
  }, [dispatch]);

  return (
    <SignalRContext.Provider value={{ conectado }}>
      {children}
    </SignalRContext.Provider>
  );
};

// Hook personalizado por si algún componente necesita saber si el WebSocket está vivo (ej. mostrar un led verde/rojo)
export const useSignalR = () => useContext(SignalRContext);
